export var THUMBNAIL_BUTTONS_BEHAVIOR;
(function (THUMBNAIL_BUTTONS_BEHAVIOR) {
    THUMBNAIL_BUTTONS_BEHAVIOR[THUMBNAIL_BUTTONS_BEHAVIOR["ON_HOVER"] = 0] = "ON_HOVER";
    THUMBNAIL_BUTTONS_BEHAVIOR[THUMBNAIL_BUTTONS_BEHAVIOR["ALWAYS"] = 1] = "ALWAYS";
})(THUMBNAIL_BUTTONS_BEHAVIOR || (THUMBNAIL_BUTTONS_BEHAVIOR = {}));
//# sourceMappingURL=thumbnail-buttons-behavior.js.map